import { Component } from '@verndale/core';
import '../../scss/modules/img-carousel.scss';
import 'swiper/css';
import { BREAKPOINTS } from '../helpers/helpers';
import { eventBus, initialBreakpoint } from '../helpers/resize';
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

class ImageCarousel extends Component {
  private swiper: Splide | null = null;
  private index = 1;
  private of = 0;
  private spanPagination: HTMLSpanElement | null = null;
  private slidesPerBreakpoint: { [key: string]: number };

  constructor(el: HTMLElement) {
    super(el);

    this.slidesPerBreakpoint = {
      mobile: 1,
      tablet: 2,
      tabletLandscape: 2,
      desktop: 3,
      wide: 4
    };
    this.index = 1;
    this.of = (this.dom.slides as NodeList)?.length || 0;
    this.spanPagination = document.createElement('p');
    this.spanPagination.className = 'img-carousel__pagination';
    this.spanPagination.textContent = `${this.index.toString()}/${this.of.toString()}`;

    this.initSwiper(initialBreakpoint());
  }
  setupDefaults() {
    this.dom = {
      swiper: this.el.querySelector<HTMLDivElement>('.splide'),
      slides: this.el.querySelectorAll<HTMLDivElement>('.splide__slide')
    };
  }

  addListeners(): void {
    eventBus.subscribe('breakpointChange', breakpoint => {
      this.initSwiper(breakpoint);
    });
  }

  checkIfCarouselNeeded(breakpoint: string) {
    if (this.of <= this.slidesPerBreakpoint[breakpoint]) {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
      this.el?.classList.add('img-carousel__no-carousel');
    }
  }

  onMountPagination = () => {
    if (this.spanPagination) {
      this.el
        .querySelector('.splide__arrow--prev')
        ?.insertAdjacentElement('afterend', this.spanPagination);
    }
  };

  initSwiper(breakpoint: string) {
    this.el?.classList.remove('img-carousel__no-carousel');
    this.swiper?.destroy();
    this.swiper = null;
    if (!this.swiper) {
      this.swiper = new Splide(this.dom.swiper as HTMLElement, {
        type: 'loop',
        rewind: false,
        perMove: 1,
        perPage: 4,
        gap: '24px',
        padding: '120px',
        pagination: false,
        breakpoints: {
          [BREAKPOINTS.tablet - 1]: {
            perPage: 1,
            gap: '16px',
            padding: '40px'
          },
          [BREAKPOINTS.tabletLandscape - 1]: {
            perPage: 2,
            gap: '16px',
            padding: '60px'
          },
          [BREAKPOINTS.wide - 1]: {
            perPage: 3,
            gap: '24px',
            padding: '120px'
          }
        }
      }).mount();

      this.swiper.on('resized', () => {
        this.onMountPagination();
      });
      this.onMountPagination();
      this.swiper.on('move', index => {
        if (this.spanPagination) {
          this.index = index + 1;
          this.spanPagination.textContent = `${this.index.toString()}/${this.of.toString()}`;
        }
      });
    }

    this.checkIfCarouselNeeded(breakpoint);
  }
}

export default ImageCarousel;
